// ── Role Constants ───────────────────────────────────────────────────────────
// Single source of truth for all role identifiers across the application

export const ROLES = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  SALES: "sales",
  BROKER: "broker",
  AGENT: "agent",
  CONSUMER: "customer",
} as const

// Type helper for role values
export type RoleValue = (typeof ROLES)[keyof typeof ROLES]

// All role values as array for easy iteration
export const ROLE_VALUES: RoleValue[] = [
  ROLES.SUPER_ADMIN,
  ROLES.ADMIN,
  ROLES.SALES,
  ROLES.BROKER,
  ROLES.AGENT,
  ROLES.CONSUMER,
]

// Display labels for each role
export const ROLE_LABELS: Record<RoleValue, string> = {
  [ROLES.SUPER_ADMIN]: "Super Admin",
  [ROLES.ADMIN]: "Admin",
  [ROLES.SALES]: "Sales Person",
  [ROLES.BROKER]: "Broker",
  [ROLES.AGENT]: "Agent",
  [ROLES.CONSUMER]: "Customer",
}

// Role style classes for UI badges
export const ROLE_STYLES: Record<RoleValue, string> = {
  [ROLES.SUPER_ADMIN]:
    "bg-purple-100 text-purple-700 dark:bg-purple-900/40 dark:text-purple-300",
  [ROLES.ADMIN]:
    "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-300",
  [ROLES.SALES]:
    "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300",
  [ROLES.BROKER]:
    "bg-nova-100 text-nova-700 dark:bg-nova-900/40 dark:text-nova-300",
  [ROLES.AGENT]:
    "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300",
  [ROLES.CONSUMER]:
    "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
}
